/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-native/no-inline-styles */
import React, { useMemo, useState } from 'react';
import { Image, StyleSheet, View } from 'react-native';
import { Button, Icon, List, MD2Colors, Switch, Text } from 'react-native-paper';
import { useDispatch, useSelector } from 'react-redux';
import { doPut } from '../../services/http';
import { errorHandler } from '../../services/Utils';
import { hideLoader, showLoader } from '../../store/info.slice';
import StockModal from './StockModal';

function Item({ item, category, isCartItem, onUpdateItemStatus, onUpdateItemStockQty, counter }) {
  const dispatch = useDispatch();
  const info = useSelector(state => state.customer?.customer);
  const [stock, setStock] = useState(item.stock_qty || 0);
  const [modalVisible, setModalVisible] = useState(false);
  const assets = useSelector(state => state.info.info.assets);

  const onToggleSwitch = () => {
    dispatch(showLoader());
    doPut('item', { canteen_id: item?.canteen_id, item_id: item.item_id, item_status: !item?.item_status })
      .then(response => {
        dispatch(hideLoader());
        if (onUpdateItemStatus) {
          onUpdateItemStatus({ canteen_id: item?.canteen_id, item_id: item?.item_id, item_status: !item?.item_status });
        }
      })
      .catch(error => {
        errorHandler(error);
      });
  };

  const handleUpdateStock = newStock => {
    dispatch(showLoader());
    doPut('item-qty', { canteen_id: item?.canteen_id, item_id: item.item_id, new_stock: newStock, prev_stock: item.stock_qty })
      .then((res) => {
        dispatch(hideLoader());
        setStock(res?.data?.stock_qty);
        console.log(`Updated stock for ${item.item_name}: ${newStock}`);
        onUpdateItemStockQty();
      })
      .catch(error => {
        errorHandler(error);
      });
  };

  const onStockButtonPress = () => {
    if (!info?.customer_settings?.disable_inventory_edit) {
      setModalVisible(true);
    }
    return;
  };

  const renderDescription = () => {
    return (
      <View style={{ justifyContent: 'flex-start' }}>
        <View
          style={{ flexDirection: 'row', alignItems: 'center', marginTop: 4 }}>
          <Text style={isCartItem ? { marginLeft: 22 } : {}}>
            {info?.currency_symbol} {item?.item_price}
          </Text>
          {!!item?.has_inventory && counter?.settings?.enable_cc_inventory && (
            <Button mode="text" labelStyle={{ textDecorationLine: 'underline' }} onPress={() => onStockButtonPress()}>Stock: {stock}</Button>
          )}
        </View>
        {!!item?.item_description && (
          <Text style={{ marginTop: 4 }}>{item?.item_description}</Text>
        )}
        <StockModal
          visible={modalVisible}
          closeModal={() => setModalVisible(false)}
          item={item}
          onUpdateStock={handleUpdateStock}
        />
      </View>
    );
  };

  const getItemTypeIconColor = () => {
    if (item?.item_type === 'non_veg' || item?.item_type === 'non veg') {
      return '#FF0000';
    } else if (item?.item_type === 'veg') {
      return '#008000';
    } else if (item?.item_type === 'egg') {
      return '#FFA500';
    } else if (item?.item_type === 'vegan') {
      return '#4CAF50';
    }
  };

  const assetMap = useMemo(
    () =>
      Object.fromEntries(
        (assets || []).map(a => [a.asset_name?.toLowerCase(), a.asset_url]),
      ),

    [assets],
  );
  const assetUrl = assetMap[item?.item_type?.toLowerCase()];

  const renderTitle = () => {
    return (
      <View style={{ justifyContent: 'flex-start' }}>
        <View
          style={{ flexDirection: 'row', alignItems: 'center', marginTop: 4 }}>
          {assetUrl ? (
            <Image
              source={{ uri: assetUrl }}
              style={styles.assetIcon}
              resizeMode="contain"
            />
          ) : (
            <Icon
              source="square-circle"
              size={16}
              color={getItemTypeIconColor(item?.item_type)}
            />
          )}
          <Text variant="titleSmall" style={{ marginHorizontal: 6 }}>
            {item?.item_name}
          </Text>
        </View>
      </View>
    );
  };

  return (
    <List.Item
      style={{ backgroundColor: '#ffffff' }}
      title={renderTitle}
      description={renderDescription}
      descriptionEllipsizeMode="tail"
      titleNumberOfLines={2}
      right={props => (
        <View style={{ justifyContent: 'flex-start' }}>
          <Switch disabled={category?.category_status === false} value={item?.item_status} color={MD2Colors.green900} onValueChange={onToggleSwitch} />
        </View>
      )}
    />
  );
}

export default Item;

const styles = StyleSheet.create({
  assetIcon: {
    width: 18,
    height: 18,
    marginRight: 4,
  },
});